import React, { useState, useEffect } from "react";
import { X, Download, ChevronLeft, ChevronRight, FileText } from "lucide-react";
import { renderAsync } from "docx-preview";
import { Document, Page, pdfjs } from "react-pdf";
import { Worker } from "@react-pdf-viewer/core";
import * as pdfjsLib from "pdfjs-dist";
import { Viewer } from "@react-pdf-viewer/core";

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`;

const documents = [
  {
    name: "Investment Application.doc",
    date: "22-01-2024 | 12:33AM",
    size: "124 KB",
    content: [
      "This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.This is the first page of Investment Application.",
      "This is the second page of Investment Application.",
      "This is the third page of Investment Application.",
    ],
  },
  {
    name: "Compliance Application.doc",
    date: "22-01-2024 | 12:33AM",
    size: "124 KB",
    content: ["Compliance details - Page 1.", "Compliance details - Page 2."],
  },
  {
    name: "Legal Application.doc",
    date: "22-01-2024 | 12:33AM",
    size: "124 KB",
    content: [
      "Legal agreement terms and conditions - Page 1.",
      "Legal agreement terms and conditions - Page 2.",
      "Legal agreement terms and conditions - Page 3.",
    ],
  },
];

const DocumentPopup = ({ isOpen, onClose, files }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [numPages, setNumPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [docxContent, setDocxContent] = useState(null);
  const handleFileSelect = async (index) => {
    setSelectedIndex(index);
    setCurrentPage(1); // Reset pagination
    const file = files[index];

    if (file.file_name.endsWith(".docx")) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;
        const container = document.createElement("div");

        // Use renderAsync instead of docxPreview.render
        await renderAsync(new Uint8Array(arrayBuffer), container);
        setDocxContent(container.innerHTML);
      };
      reader.readAsArrayBuffer(file);
    } else {
      setDocxContent(null);
    }
  };
  useEffect(() => {
    handleFileSelect(0);
  }, []);

  const selectedDoc = documents[selectedIndex];

  const nextPage = () => {
    if (currentPage < selectedDoc.content.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const selectDocument = (index) => {
    setSelectedIndex(index);
    setCurrentPage(0); // Reset pagination when switching documents
  };
  const formatDateTime = (dateString) => {
    const [datePart, timePart, meridian, timezone] = dateString.split(" ");
    const [day, month, year] = datePart.split("/");
    const [hours, minutes] = timePart.split(":");

    // Convert 24-hour format to 12-hour format
    const hours12 = (+hours % 12 || 12).toString();
    const formattedTime = `${hours12}.${minutes}${meridian}`;
    return `${day}/${month}/${year} | ${formattedTime}`;
  };
  return (
    <div className="fixed py-4 inset-0 px-2 md:px-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      {/* Modal Container */}
      <div className="bg-white md:h-auto h-[90vh] w-full max-w-6xl rounded-lg shadow-lg overflow-auto md:overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold">Application Documents</h2>
          <button onClick={onClose}>
            <img src="/add.svg" alt="Close" className="w-10 h-10" />{" "}
          </button>
        </div>

        {/* Content */}
        <div className="p-4 flex flex-col md:flex-row gap-4">
          {/* Left Side: Document List */}
          <div className="md:w-1/3 md:h-[90vh] md:overflow-y-auto space-y-3">
            {files.map((doc, index) => (
              <div
                key={index}
                className={`p-3 border rounded-lg flex items-center cursor-pointer relative ${
                  selectedIndex === index ? "bg-gray-200" : ""
                }`}
              >
                {/* Left Image */}
                <img
                  src="/document-text.svg"
                  alt={`${doc.file_name}`}
                  className="w-10 h-10 object-cover mr-3"
                />

                {/* Center Content */}
                <div
                  onClick={() => handleFileSelect(index)}
                  className="flex-1 text-left"
                >
                  <h3 className="text-sm font-semibold">{doc.file_name}</h3>
                  <p className="text-xs font-medium">
                    {formatDateTime(doc.date_uploaded)}
                  </p>
                  <p className="text-xs font-semibold">{doc.size}</p>
                </div>

                {/* Bottom Right Download Button */}
                {selectedIndex !== index && (
                  <a
                    href={doc.presigend_url}
                    download={doc.file_name}
                    className="text-black underline text-xs font-medium absolute bottom-2 right-2"
                  >
                    Download
                  </a>
                )}
              </div>
            ))}
          </div>

          {/* Right Side: Document Content Preview with Pagination */}
          <div className="md:w-2/3  flex flex-col items-center bg-gray-100 rounded-lg p-6">
            <h3 className="text-md font-semibold mb-2">
              {files[selectedIndex].file_name}
            </h3>

            {files[selectedIndex].file_name.endsWith(".pdf") ? (
              // Render PDF Pages
              <div className="w-full h-[60vh] flex flex-col items-center">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <Viewer
                    className="w-full    rounded-md shadow-none"
                    fileUrl={files[selectedIndex].presigend_url}
                  />
                </Worker>
                {/* <Document
                  file={files[selectedIndex]}
                  onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                  className="w-full"
                >
                  <Page pageNumber={currentPage} />
                </Document> */}
              </div>
            ) : files[selectedIndex].file_name.match(/\.(jpeg|jpg|png)$/i) ? (
              // Render DOCX Content
              <div className="w-full h-auto md:h-[60vh] overflow-auto  bg-white border rounded-md">
                <img
                  src={files[selectedIndex].presigend_url}
                  alt={files[selectedIndex].file_name}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            ) : (
              <p className="text-sm text-gray-700 text-center">
                No preview available
              </p>
            )}
            <div className="flex justify-center mt-10">
              <a
                href={files[selectedIndex].presigend_url}
                download={files[selectedIndex].file_name}
                className="text-white  underline py-2 px-6 rounded-full bg-black  flex items-center gap-2"
              >
                <img
                  src="/document-download-white.svg"
                  alt="Download"
                  className="h-5 w-5"
                />
                Download
              </a>
            </div>
          </div>
        </div>

        {/* Footer */}
      </div>
    </div>
  );
};
export default DocumentPopup;
